<template>
    <div>
        <div id="AgendaDeAudiencias_div" class="w-100 px-5 py-4">
            <div id="TituloAgendaDeAudiencias_div">
                <h1 style="margin-bottom: 0px;">Complementación de Sesión de Audiencia</h1>
                <h3 style="margin-top: 0px;">Complementa una sesión de Audiencia con una fuente de grabación 7/24hrs</h3>
            </div>
            <div class="row d-flex">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low">
                    <div class="area">
                        <div class="row" v-if="sesionDeLaAudiencia!=undefined && sesionDeLaAudiencia!=null">
                            <div class="form-group">
                                <h4>{{sesionDeLaAudiencia.Audiencia.Area.Nombre}}</h4>
                                <br/>
                                <h5>{{sesionDeLaAudiencia.Audiencia.TipoDocumento.Nombre}}  {{sesionDeLaAudiencia.Audiencia.Consecutivo}}</h5>
                            </div>
                        </div>
                        <div class="row">
                                <div class="form-group col-9">
                                    <label>Juez</label>
                                    <input type="file" id="videoJuez" v-on:change="cargarArchivo($event)" class="form-control" accept=".mp4" style="width: 100%"/>
                                </div>
                                <div class="form-group col-3">
                                    <label>Fecha de Finalización:</label>
                                    <input type="date" id="fechaFinalizacion"  class="form-control" v-model="FechaDeFinalizacion"/>
                                </div>
                        </div>
                        <div class="row">
                                <div class="form-group col-9">
                                    <label>Defensor</label>
                                    <input type="file" id="videoDefensor" v-on:change="cargarArchivo($event)" class="form-control" accept=".mp4" style="width: 100%"/>
                                </div>
                                <div class="form-group col-3">
                                    <label>Duración Aproximada:</label>
                                    <input type="text" id="duracion" class="form-control" v-model="duracion_Sesion" placeholder="00:00:00" v-mask="'##:##:##'"/>
                                </div>
                        </div>
                        <div class="row">
                                <div class="form-group col-9">
                                    <label>Ministerio Público</label>
                                    <input type="file" id="videoMP" v-on:change="cargarArchivo($event)" class="form-control" accept=".mp4" style="width: 100%"/>
                                </div>
                                <div class="text-right col-3">
                                    <button class="btn btn-sm btn-dark overwrapDeBotones"  @click='iniciarComplemento()'>Iniciar Proceso en Sesión de Audiencia</button>
                                </div>
                        </div>
                        <div class="row">
                                <div class="form-group col-9">
                                    <label>Testigo</label>
                                    <input type="file" id="videoTestigo" v-on:change="cargarArchivo($event)" class="form-control" accept=".mp4" style="width: 100%"/>
                                </div>
                        </div>
                        <div class="row">
                                <div class="form-group col-9">
                                    <label>Testigo Protegido</label>
                                    <input type="file" id="videoProtegido" v-on:change="cargarArchivo($event)" class="form-control" accept=".mp4" style="width: 100%"/>
                                </div>
                        </div>
                        <div class="row">
                                <div class="form-group col-9">
                                    <label>Público</label>
                                    <input type="file" id="videoPublico" v-on:change="cargarArchivo($event)" class="form-control" accept=".mp4" style="width: 100%"/>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import enumeraciones from '@/../static/js/enumeraciones'
import comun from '@/../static/js/comun'
import catalogos from '@/../static/js/catalogos'
import api from '@/../static/js/api'
import axios from 'axios'
import router from '@/router/index'
import VueMask from 'v-mask'

Vue.use(VueMask);

export default {
    data() {
      return {
          enumeraciones,
          archivos: [],
          sesionDeLaAudiencia : null,
          duracion_Sesion: "",
          FechaDeFinalizacion: ""
      }
    },
    props: {
        SesionId : {type: Number, default : 0}
    },
    methods: {
        cargarArchivo: function (evento){
            console.log(evento.target.files[0]);

            let idDelTipoVideo = 0;
            switch(evento.target.id)   
            {
                case "videoJuez":
                    idDelTipoVideo = 1;
                    break;
                case "videoDefensor":
                    idDelTipoVideo = 2;
                    break;
                case "videoMP":
                    idDelTipoVideo = 3;
                    break;
                case "videoTestigo":
                    idDelTipoVideo = 4;
                    break;
                case "videoProtegido":
                    idDelTipoVideo = 5;
                    break;
                 case "videoPublico":
                    idDelTipoVideo = 6;
                    break;
            }
            if(evento.target.files.length>0)
            {
                let RutaServidor = "//"+ this.sesionDeLaAudiencia.Sala.IP + '/NVR/'
                let archivoDefinido = RutaServidor + evento.target.files[0].name;
                if(this.archivos.find(e=>e.Id == idDelTipoVideo))
                {
                    var indice = this.archivos.indexOf(this.archivos.find(e=>e.Id == idDelTipoVideo));
                    this.archivos.splice(indice,1);
                }
                this.archivos.push({"Id": idDelTipoVideo, "Archivo": archivoDefinido})
                       
            }
            else
            {
                var indice = this.archivos.indexOf(this.archivos.find(e=>e.Id == idDelTipoVideo));
                this.archivos.splice(indice,1);
            }
            this.archivos.sort((a,b)=>(a.Id>b.Id ? 1:-1));
        },
        iniciarComplemento: async function (){
            let _this = this;
            let peticion = {
                        "NVR": this.archivos,
                        "Sesion": {
                            "RutaFinal" : this.sesionDeLaAudiencia.RutasDeVideos[0].Ruta
                        }
                    };
            if(this.archivos.length>=4 && this.archivos.length<=6)
            {
                if(this.validaParametros())
                {
                    bootbox.confirm({
                    title: "Mensaje del sistema",
                    message: "¿Esta Operacion puede tardar algunos minutos, Desea Continuar?",
                    buttons: {
                        cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                        },
                        confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Iniciar'
                        }
                    },
                    callback: (response) => {
                        if (response) {
                            
                            comun.SeEstaCargandoInformacion(true);
                            axios.post(
                            'http://' + this.sesionDeLaAudiencia.Sala.IP + this.sesionDeLaAudiencia.Sala.PuertoDeGrabacion + '/IniciarVideosNVR',
                            peticion,
                            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                            ).then(respuesta => {
                                if (respuesta.data.Error ) {
                                    console.log(respuesta);
                                    comun.mensajeDeAlerta(respuesta.data.Mensaje, null, null);
                                    comun.SeEstaCargandoInformacion(false);
                                } 
                                else 
                                {
                                    comun.SeEstaCargandoInformacion(false);
                                    if(respuesta.data.Satisfactorio==true)
                                    {
                                        //actualiza base de datos
                                        this.finalizaSesionEnDB();
                                        comun.SeEstaCargandoInformacion(false);
                                    }
                                }
                            }
                            ).catch(excepcion => {
                            console.log(excepcion);
                            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                            comun.SeEstaCargandoInformacion(false);
                            });
                        
                        }
                    }
                    });

                    // comun.SeEstaCargandoInformacion(true);
                    // axios.post(
                    // 'http://' + this.sesionDeLaAudiencia.Sala.IP + this.sesionDeLaAudiencia.Sala.PuertoDeGrabacion + '/IniciarVideosNVR',
                    // peticion,
                    // comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                    // ).then(respuesta => {
                    //     if (respuesta.data.SiHayError ) {
                    //         console.log(respuesta);
                    //         comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    //         comun.SeEstaCargandoInformacion(false);
                    //     } 
                    //     else 
                    //     {
                    //         comun.SeEstaCargandoInformacion(false);
                    //         if(respuesta.data.Satisfactorio==true)
                    //         {
                    //             //actualiza base de datos
                    //             this.finalizaSesionEnDB();
                    //             comun.SeEstaCargandoInformacion(false);
                    //         }
                    //     }
                    // }
                    // ).catch(excepcion => {
                    // console.log(excepcion);
                    // comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    // comun.SeEstaCargandoInformacion(false);
                    // });
                }
            }
            else
            {
                comun.mensajeDeAlerta("Al Menos 4 videos deben ser definidos", null, null);
            }
        },
        obtenerSesionDeAudiencia(Id){
            comun.SeEstaCargandoInformacion(true);
            const parametros = {
                SesionDeLaAudienciaId: Id,
                EsPrueba: this.enumeraciones.EsPrueba
            };
            axios.post(
            api.conexion + api.Forseti.sistema.audiencias.audienciaspendientes.ObtenSesionDeLaAudienciaPendiente,
            parametros,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
            ).then(respuesta => {
                if(respuesta.data.SiHayError){
                console.log(respuesta);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                } else {
                this.sesionDeLaAudiencia = respuesta.data.SesionDeLaAudienciaPendiente; 
                }
                comun.SeEstaCargandoInformacion(false);
            }
            ).catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);
                router.push({ name: "PanelDeAudienciasPendientes" });
            });
        },
        finalizaSesionEnDB: async function(){
            let parametros = {
                SesionDeLaAudienciaId: this.SesionId,
                fechaDeFinalizacion: this.FechaDeFinalizacion,
                DuracionDeLaSesion: "00:00",//this.tiempo.Horas + ":" + this.tiempo.Minutos + ":" + this.tiempo.Segundos,
                EsPrueba: this.enumeraciones.EsPrueba
            }
            axios.post(
            api.conexion + api.Forseti.sistema.audiencias.audienciaspendientes.FinalizarSesionDeLaAudiencia,
            parametros,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
            ).then(respuesta => {
                if(respuesta.data.SiHayError){
                    comun.mensajeDeAlerta(respuesta.Error.Mensaje, null, null);
                            
                } 
                else 
                {
                    router.push({name: "EdicionYAsignacion", params:{ AudienciaId: this.sesionDeLaAudiencia.Audiencia.AudienciaId } })
                    comun.mensajeDeAlerta("Se ha Registrado la sesión correctamente", null, null);
                }
            }
            ).catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);
            });
        },
        validaParametros(){
    
            if(this.FechaDeFinalizacion==null || this.FechaDeFinalizacion==undefined || this.FechaDeFinalizacion=="")
            {
                comun.mensajeDeAlerta("Defina fecha de inicio de la Sesión", null, null);
                return false;
            }
            if(this.duracion_Sesion=="")
            {
                comun.mensajeDeAlerta("Defina duración de la Sesión", null, null);
                return false;
            }
            if(parseInt(this.duracion_Sesion.split(":")[0])==0 && parseInt(this.duracion_Sesion.split(":")[1])==0 && parseInt(this.duracion_Sesion.split(":")[2])==0)
            {
                
                comun.mensajeDeAlerta("Defina duración de la Sesión", null, null);
                return false;
            }
            if(parseInt(this.duracion_Sesion.split(":")[1])>60 || (this.duracion_Sesion.split(":")[2])>60)
            {
                comun.mensajeDeAlerta("Formato no valido en duración de sesión", null, null);
                return false;
            }
            return true;
        }
    },
    mounted() {
        this.obtenerSesionDeAudiencia(this.SesionId)
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Forseti/Audiencias/PanelDeAudienciasPorVerificar/ComplementacionNVR.vue